import { createContext } from "react";

const OpenWeatherMapContext = createContext({
  apiKey: null,
  cityIdApiKey: null,
  setApiKeys: (acccountApiKey, cityIdApiKey) => {},
  unsetApiKeys: () => {},
});

export default OpenWeatherMapContext;
